import { render } from "./ActionsManager.vue?vue&type=template&id=7287c6a2&scoped=true"
import script from "./ActionsManager.vue?vue&type=script&lang=js"
export * from "./ActionsManager.vue?vue&type=script&lang=js"

import "./ActionsManager.vue?vue&type=style&index=0&id=7287c6a2&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7287c6a2"]])

export default __exports__